import React from "react";
import {Navigate} from "react-router-dom";
import UserProfile from "../../auth/Profile/UserProfile";

const PrivateRouteProfile = () => {
    if (localStorage.getItem('isConnected') && localStorage.getItem('accessToken')) {
        return <UserProfile/>;
    }
    return <Navigate to="/login"/>
}

export default PrivateRouteProfile;
